<template>
	<div class="aboutcom">
		<div class="comtop">
			<img src="../../static/img/aboutcom.jpg"/>
			<div class="bannerMask"><div></div></div>
			<div class="com-titr">
				<span>
					<img src="../../static/img/abouticon.png"/><b>关于我们</b>
				</span>
				<p>专业的IT解决方案服务商。主要从事于计算机系统集成、软件开发、IT运<br />维服务等业务，服务于 政府、学校、医疗、生产企业等行业。</p>
			</div>
		</div>
		<div class="com-detail" >
			<div class="com-top-top">
				<h4>{{center[chalid].title}}</h4>
				<div class="com-line">
					
				</div>
			</div>
			<!--
            	描述：公司简介
            -->
            <transition name="zhaopin-fade">
            <div class="cominfo" v-if="chalid == 0 ">
				<h4 class="small-tit">{{center[chalid].smalltit}}</h4>
					<p class="com-content"><b>广东思程科技有限公司</b>是一家专业的IT解决方案服务商。主要从事于计算机系统集成、软件与数据服务、IT运维服务等业务，服务于政府、学校、医疗、生产企业等行业。</p> 
					<p>公司历经市场的考验，始终坚持紧跟时代步伐，积极引进、培养人才，经过十多年的耕耘，公司已拥有了一支成熟的专业技术队伍，能为用户提供全面
					的IT技术解决方案，能满足大型的信息化系统集成项目的管理与服务要求。此外，公司积极投入自主创新 研发，针对不同行业，推出了具有自己特色的解决
					方案。 
					</p> 
					<p>未来我们将一如既往的关注客户的需求，专注于技术创新，以为客户提供专业的技术服务为目标，使客户得到最大的效益，我们真诚期待与广大客户精
					诚合作，共创辉煌！
					</p>
				<div class="imgcomab" v-for="im in comimg">
					<img :src="im.imgsrc"/>
				</div>
            </div>
            <div class="cominfo" v-if="chalid == 1 ">
					<p class="com-content"> 一直以来，广东思程科技都注重人才的管理和培养，努力建立一流的团队和学习型组织，充分挖掘每一个成员的潜力，让员工在工作中实现自我价值，我们最宝贵的财富是我们的员工。</p> 
					<div class="singleimg">
						<img src="../../static/img/frame.jpg"/>
					</div>
            </div>
            <div class="cominfo" v-if="chalid == 2 ">
					<div class="singlewimg">
						<img src="../../static/img/wenhua.png"/>
					</div>
					<div class="comwenhua">
						<div class="wencom" v-for="wcom in wenhua">
							<h3>{{wcom.wentit}}</h3>
							<p><span class="glyphicon glyphicon-triangle-right"></span>&nbsp;&nbsp;&nbsp;{{wcom.wencontent}}</p>
						</div>
					</div>
            </div>
			<!-- 资质荣誉 -->
            <div class="cominfo" v-if="chalid == 3 ">
				<p class="com-content">惠州市德通科技有限公司成立于2004年，2012年公司变更冠名为广东思程科技有限公司，逐步发展成为了专业的信息化服务企业。</p> 
				<!-- <div class="honor" v-for="ho in honor">
					<img :src="ho.hoimg"/>
				</div> -->
				<!-- <div class="honortit" v-for="hot in honorname">
					<p><b>{{hot.honame}}</b></p>
				</div> -->
				<div class="certificate" v-for="item in honor" >
					<div class="pic" :style="{'background-image': 'url('+  item.hoimg +')'}">
					</div>
					<div class="message">
						{{item.honame}}
					</div>
				</div>
				
            </div>
            <div class="newsinfo" v-if="chalid == 4 ">
				<div class="aboutnewslist">
					<div class="aboutnewsli">
						<ul>
							<li v-for="newsli in news" @click="todetail(newsli.ID)">{{newsli.title}}
							<div class="aboutlidata">
								{{newsli.createDate}}
							</div>
							</li>
						</ul>
					</div>
				</div>
            </div>
            </transition>
		</div>
	</div>
</template>

<script>
	export default{
		name : 'aboutcom',
		data(){
			return {
				top : [
				{id : 0 , imgsrc : 'static/img/aboutcom.jpg' , title : '关于我们'},
				],
				center : [
				{id : 0 , imgsrc : 'static/img/aboutcom.jpg' , title : '公司简介' , smalltit : '专业的信息化服务商'},
				{id : 1 , imgsrc : 'static/img/aboutcom.jpg' , title : '组织框架' , smalltit : '专业的信息化服务商'},
				{id : 2 , imgsrc : 'static/img/aboutcom.jpg' , title : '企业文化' , smalltit : '专业的信息化服务商'},
				{id : 3 , imgsrc : 'static/img/aboutcom.jpg' , title : '资质荣誉' , smalltit : '专业的信息化服务商'},
				{id : 4 , imgsrc : 'static/img/aboutcom.jpg' , title : '新闻资讯' , smalltit : '专业的信息化服务商'},
				],
				chalid : 0,
				comimg : [
				{id :　0　, imgsrc : 'static/img/comabout1.jpg'},
				{id :　1　, imgsrc : 'static/img/comabout2.jpg'},
				],
				news : [
		    	],
				wenhua :[
				{id : 0 , wentit : '责任感' , wencontent : '我们的企业要有社会责任感，我们的员工对公司、客户、家庭要勇于负责任'},
				{id : 1 , wentit : '团队精神' , wencontent : '我们的企业是一个团队，每个员工都必须充分认可团队、依靠团队、配合 团队、才能形成一个有战斗力的队伍'},
				{id : 2 , wentit : '专业服务、技术创新' , wencontent : '拥有专业的技术、良好的服务能力，展现IT行业的“工匠”精神'},
				{id : 3 , wentit : '管理的规范化与制度化' , wencontent : '我们相信：企业的长远发展需要管理的规范化与运营的制度化'},
				{id : 4 , wentit : '勤劳、诚实、自信、超越自我的精神' , wencontent : '我们希望我们的员工是一个勤奋、诚实可靠、有自信、勇于超越自我的人'},
				],
				honor :[
				{id : 1 , hoimg : 'static/img/zz13.jpg', honame : '■ 广东省安全技术防范系统设计、施工、维修资格证（贰级）证书'},
				{id : 2 , hoimg : 'static/img/zz19.jpg', honame : '■ 安全生产许可证'},
				{id : 3 , hoimg : 'static/img/zz6.jpg', honame : '■ 软件企业认定证书'},
				{id : 4 , hoimg : 'static/img/zz12.jpg', honame : '■ 质量管理体系认证证书'}, 
				{id : 5 , hoimg : 'static/img/zz14.jpg', honame : '■ 高新技术企业证书'},
				{id : 6 , hoimg : 'static/img/zz11.jpg', honame : '■ 守合同重信用企业（连续十三年）'},
				{id : 7 , hoimg : 'static/img/zz15.jpg', honame : '■ 信息技术服务管理体系认证证书'}
				],
				honorname :[
				{id : 1 , honame : '■ 广东省安全技术防范系统设计、施工、维修资格证（贰级）证书'},
				{id : 2 , honame : '■ 安全生产许可证'},
				{id : 3 , honame : '■ 软件企业认定证书'},
				{id : 4 , honame : '■ ISO9001 2020质量管理体系认证证书'},
				{id : 5 , honame : '■ 高新技术企业证书'},
				{id : 6 , honame : '■ 守合同重信用企业（连续十三年）'},
				{id : 7 , honame : '■ ISO/IEC 20000信息技术服务管理体系认证证书'}
				],
				scrollWatch: true
			}
		},
		mounted(){
			this.getID();
			this.getnews();
		},
		methods : {
			getID(){
				this.chalid = this.$route.params.ID
			},
			getnews(){
     			// 	this.$http.post('http://www.gd-sc.net:9090',{table : 'news'},{emulateJSON: true}).then((response) => {
			    //     for(var i=0 ; i<response.body.length ; i++){
			    //     	var data =  response.body[i].createDate;
			    //     	response.body[i].createDate = data.substr(0,10)
			    //     }
			    //     this.news = response.body;
			    //   })
     		},
     		todetail(id){
     			this.$router.push('/Newsdetail/'+id);
     		},
		},
	}
</script>

<style>
	.aboutcom{
		position: relative;
		clear: both;
		width: 100%;
		margin: 0 auto;
	}
	.comtop{
		margin-top: -3vw;
		position: relative;
		width: 100%;
		clear: both;
	}
	.comtop img{
		width: 100%;
	}
	.aboutcom .com-titr{
		width: 40%;
		position: absolute;
		clear: both;
		z-index: 3;
		top: 12vw;
	    right: 0vw;
	    text-align: left;
	    font-size: 22px;
	    color: #fff;
	}
	.com-titr img {
	    width: 4% !important;
	    margin-right: 23px;
	}
	.com-titr p{
		margin-top: 20px;
		font-size: 14px;
		line-height: 28px;
	}
	.com-titr b{
		font-size: 25px;
	    position: relative;
	    top: 3px;
	}
	.com-detail{
		width: 80%;
		margin: 0px auto 60px;
		position: relative;
		clear: both;
		text-align: left;
	}
	.com-detail h4{
		font-weight: 700;
		margin-left: 50px;
		font-size: 22px;
	}
	.com-line{
		width: 25px;
		height: 3px;
		position: absolute;
		background: #1975f0;
		border-radius: 4px;
		top: 8px;
	}
	.com-top-top{
		width: 100%;
		border-bottom: 1px solid #ddd;
		position: relative;
		padding-bottom: 10px;
		margin-bottom: 20px;
	}
	.com-detail h4.small-tit{
		text-align: center;
		width: 500px;
		margin: 0 auto;
		position: relative;
		color: #0066ef ;
		font-weight: 500;
	}
	.cominfo{
		position: relative;
		clear: both;
		padding: 2%;
	}
	.newsinfo{
		position: relative;
		clear: both;
		padding: 0%;
	}
	.cominfo p{
		color: #666666;
		line-height: 35px;
		margin: 30px auto;
		font-size: 18px;
		text-indent:2em;
	}
	.cominfo img{
		text-align: center;
	}
	.imgcomab{
		width: 49%;
		position: relative;
		clear: both;
		display: inline-block;
		vertical-align: top;
		text-align: center;
	}
	.imgcomab img{
		width: 85%;
	}
	.singleimg,.singlewimg{
		width:100%;
		position: relative;
		margin: 0 auto;
		text-align: center;
	}
	.singleimg img{
		width: 75%;
	}
	.singlewimg img{
		width: 100%;
	}
	.comwenhua h3{
		color: #e03500;
		font-weight: 900;
		font-size: 22px;
	}
	.comwenhua p{
		text-indent:.5em;
	}
	.comwenhua span{
		color: #e03500;
	}
	.comwenhua{
		position: relative;
		margin-top: 45px;	
	}
	.wencom{
		position: relative;
		margin-top: 10px;
	}
	.honor{
		position: relative;
		width: 25%;
		clear: both;
		display: inline-block;
		margin: 20px auto;
		text-align: center;
	}
	.honor img{
		width: 85%;
   		height: 192px;
   		transition: .5s all;
	}
	.honor img:hover{
		transform: scale(1.1);
	}

	.aboutnewsli {
    	position: relative;
    	clear: both;
    	margin-top: 10px;
	}
	.aboutnewsli li{
		position: relative;
		clear: both;
		padding: 15px 0;
		border-bottom: 1px dashed #dfdfdf;
	}
	.aboutlidata{
		position: absolute;
		right: 0;
		top: 15px;
		color: #ea2626;
	}
	.certificate {
		width:25%;
		display:inline-block;
		padding: 10px 10px 20px;
		vertical-align: top;
	}
	.certificate .pic {
		width: 100%;
		height: 20vw;
		background-repeat:no-repeat;
		background-size:100% 100%;
		/* border: 1px solid #999; */
		/* background: url('') center no-repeat / contain; */
	}
	.certificate .message {
		width: 100%;
		color: #666666;
		line-height: 45px;
		font-size: 18px;
		font-weight:700;
		text-align: center;
	}
</style>


// WEBPACK FOOTER //
// src/components/aboutcom.vue